import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import ContactInfoInner from "../../../SendLetter/dialogs/ContactInfoInner";

const styles = () => ({
  root: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "36px",
  },
});

/**
 * Salesforceの連携ができないユーザーに表示するコンポーネント
 */
class SalesforceNotSupport extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.box}>
          <Typography variant="title" className={classes.sectionTitle}>
            現在ご利用のプランでは、Salesforce連携機能がサポートされていません
          </Typography>

          <ContactInfoInner />
        </div>
      </div>
    );
  }
}

SalesforceNotSupport.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SalesforceNotSupport);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceNotSupport.jsx